import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';


class ProductionNavBar extends React.Component {
    static propTypes = {
        name: PropTypes.string,
    };

    static defaultProps = {
        name: null,
    };

    renderLeftSideNav = () => (
        <a className="navbar-brand mr-auto" href={DJ_CONST.reverse['production:production']()} key="brand">
            {gettext("PMC Production")}
        </a>
    );

    renderRightSideNav = () => {
        let content = null;

        if (this.props.name === null) {
            content = (
                <a className="nav-link" href={DJ_CONST.reverse.login()}>{gettext("Log in")}</a>
            );
        } else {
            content = [
                <strong className="navbar-text text-white mr-2" key="name">
                    {this.props.name}
                </strong>,
                <a className="nav-link" href={DJ_CONST.reverse['production:production']()} key="logout">
                    {gettext("Log out")}
                </a>,
            ];
        }

        return (
            <div className="navbar-nav ml-auto flex-row" key="right-nav">
                {content}
            </div>
        );
    };

    render() {
        return [
            this.renderLeftSideNav(),
            this.renderRightSideNav(),
        ];
    }
}

const mapStateToProps = state => ({
    name: state.workers.worker ? state.workers.worker.name : null,
});


export default connect(
    mapStateToProps,
)(ProductionNavBar);



// WEBPACK FOOTER //
// ./src/components/ProductionNavBar.js